// Destination experiences: landmark / experience keywords mined from each trip's itinerary text.
// A highlight only appears on a country's holidays page when at least one trip there mentions it,
// so the Experiences filter grows by itself as products are added. Format: [label, regex, icon, alsoRequired regex?].
// To extend: run scripts/thrillophilia/suggest_highlights.py <new data files> and add the good phrases here.
export const EXPERIENCES = [
  // Cruises & boats
  ['Disney Cruise', /disney (adventure|cruise)/i, 'ship'],
  ['Genting Dream Cruise', /genting dream/i, 'ship'],
  ['Royal Caribbean cruise', /royal caribbean|spectrum of the seas/i, 'ship'],
  ['Nile cruise', /nile cruise|felucca|dahabiya|cruis\w* (on|along|down|up) the nile/i, 'ship'],
  ['Ha Long Bay cruise', /\bha ?long\b/i, 'ship'],
  ['Mekong River', /mekong/i, 'boat'],
  ['Li River cruise', /\bli river|yangshuo|guilin/i, 'boat'],
  ['Dinner cruise', /dinner cruise|chao phraya|phinisi/i, 'moon'],
  ['Sunset & dolphin cruises', /sunset cruise|dolphin cruise|dolphin watching|sunset sail/i, 'moon'],
  ['Catamaran sailing', /catamaran|sailing (trip|tour|cruise|day)|yacht/i, 'boat'],
  ['Fjord cruise', /fjord|n(æ|ae)r(ø|o)yfjord|geiranger|\bfl(å|a)m\b|mostraumen/i, 'boat'],
  ['Douro river cruise', /douro/i, 'boat'],
  ['Venice canals & gondolas', /gondola|grand canal|rialto|st\.? mark|doge|venice/i, 'boat', /venice|venezia|veneto/i],
  ['Seaplane transfers', /seaplane/i, 'star'],
  // Theme parks, shows & attractions
  ['Universal Studios', /universal studios/i, 'ticket'],
  ['Night Safari', /night safari/i, 'paw'],
  ['Singapore Zoo & River Wonders', /singapore zoo|river wonders|mandai/i, 'paw'],
  ['Gardens by the Bay', /gardens by the bay|supertree|cloud forest|flower dome/i, 'tree'],
  ['Marina Bay Sands SkyPark', /skypark|marina bay sands/i, 'camera'],
  ['Jewel Changi', /jewel changi|rain vortex/i, 'star'],
  ['Adventure Cove Waterpark', /adventure cove/i, 'wave'],
  ['S.E.A. Aquarium', /s\.?e\.?a\.? aquarium|oceanarium/i, 'wave'],
  ['Wings of Time show', /wings of time/i, 'ticket'],
  ['Singapore Flyer', /singapore flyer/i, 'camera'],
  ['Cable car rides', /cable car|skyway|skybridge|sky ?bridge|fjellheisen|teleferico|funicular/i, 'landscape'],
  ['Safari World', /safari world/i, 'paw'],
  ['Cabaret & cultural shows', /alcazar|cabaret|fantasea|siam niramit|phare|kecak|cultural show|cultural dance|kuta theatre|apsara/i, 'ticket'],
  ['Sound & light show', /sound (and|&) light/i, 'ticket'],
  ['Nong Nooch Garden', /nong nooch/i, 'tree'],
  ['Sanctuary of Truth', /sanctuary of truth/i, 'culture'],
  ['Tiger Kingdom', /tiger kingdom/i, 'paw'],
  ['Floating markets', /floating market|damnoen|amphawa|cai rang/i, 'boat'],
  ['Night markets', /night market|night bazaar|walking street market/i, 'moon'],
  ['Genting Highlands', /genting highlands|genting skyway|resorts world genting|skytropolis/i, 'landscape'],
  ['Petronas Towers', /petronas/i, 'camera'],
  ['Batu Caves', /batu caves/i, 'culture'],
  ['Ba Na Hills & Golden Bridge', /ba na|golden bridge/i, 'landscape'],
  ['Cu Chi Tunnels', /cu chi/i, 'culture'],
  ['Santa Claus Village', /santa claus|santa.?s village/i, 'snow'],
  ['Hot-air balloon ride', /hot[- ]air balloon|balloon ride|balloon flight/i, 'star'],
  // Islands, beaches & water
  ['Phi Phi Islands', /phi phi|maya bay/i, 'island'],
  ['Coral Island', /coral island|koh larn|koh hey|koh he\b/i, 'island', /thailand|phuket|pattaya|bangkok/i],
  ['Four Islands tour', /four islands?|4 islands?|koh poda|phra nang|chicken island|tup island/i, 'island'],
  ['James Bond Island', /james bond|phang nga/i, 'island'],
  ['Island hopping', /island[- ]hopping|island hop|island tour|hopping tour/i, 'island'],
  ['Snorkelling trips', /snorkel/i, 'wave'],
  ['Water sports', /parasail|banana boat|jet ?ski|water ?sports|kayak|paddleboard|surf lesson/i, 'wave'],
  ['Nusa Penida', /nusa penida|kelingking|crystal bay/i, 'island'],
  ['Manta rays & whale sharks', /manta|whale shark|hanifaru/i, 'wave'],
  ['Whale watching', /whale watching|whale[- ]watch/i, 'wave'],
  ['Overwater villas', /overwater|water villa/i, 'gem'],
  ['Lagoon kayaking', /big lagoon|small lagoon|kayangan|barracuda lake|twin lagoon|lagoon (tour|kayak)/i, 'wave'],
  ['Red Sea beaches', /hurghada|red sea|sharm el/i, 'beach', /egypt|hurghada|sharm/i],
  ['Blue Lagoon', /blue lagoon/i, 'wave'],
  ['Algarve caves & cliffs', /benagil|ponta da piedade|algarve/i, 'wave'],
  ['Hvar & the Blue Cave', /blue cave|hvar|pakleni/i, 'island'],
  ['Amalfi Coast drive', /amalfi|positano|ravello|capri/i, 'road'],
  ['Santorini caldera sunsets', /\boia\b|caldera|santorini/i, 'moon'],
  ['Archipelago islands', /archipelago|visby|gotland|marstrand/i, 'island'],
  // Wildlife & nature
  ['Elephant encounters', /elephant (sanctuary|camp|care|park|orphanage|ride|riding|bath|bathing|trek|trekking|jungle|safari|village|experience|encounter|transit|nature)|elephants? (bathing|feeding)|pinnawala|feed(ing)? (the )?elephants/i, 'paw'],
  ['Wildlife safari', /jeep safari|wildlife safari|game drive|yala|udawalawe|minneriya|chitwan|kaziranga|bako national|kinabatangan|sepilok|orangutan|proboscis/i, 'paw'],
  ['Monkey Forest', /monkey forest/i, 'paw'],
  ['Waterfalls', /(?<!indoor )waterfall|\bfalls\b|kuang si|tegenungan|gullfoss|seljalandsfoss|sk(ó|o)gafoss|khone phapheng/i, 'leaf'],
  ['Plitvice & Krka lakes', /plitvice|krka/i, 'leaf'],
  ['Rice terraces', /rice terrace|rice paddies|rice-paddy|tegallalang|longji|jatiluwih/i, 'leaf'],
  ['Tea plantations', /tea (plantation|estate|factory|country|garden)|boh tea|cameron highlands/i, 'leaf'],
  ['Mount Batur sunrise trek', /mount batur|\bbatur\b/i, 'landscape'],
  ['Volcano landscapes', /volcano|mount bromo|ijen|vesuvius|\betna\b|\btaal\b/i, 'landscape'],
  ['Mount Fuji & Hakone', /mount fuji|mt\.? fuji|fuji-?san|hakone|lake ashi|kawaguchi/i, 'landscape'],
  ['Northern Lights', /northern lights|aurora/i, 'star'],
  ['Glaciers & ice caves', /glacier|j(ö|o)kuls(á|a)rl(ó|o)n|diamond beach|ice cave/i, 'snow'],
  ['Golden Circle', /golden circle|geysir|gullfoss|thingvellir|þingvellir/i, 'landscape'],
  ['Husky & reindeer sledding', /husky|dog sled|reindeer/i, 'snow'],
  ['Glass igloos & ice hotels', /glass[- ]igloo|igloo|icehotel|ice hotel|aurora cabin/i, 'snow'],
  ['Lapland & the Arctic', /arctic circle|lapland|rovaniemi|kiruna|abisko|troms(ø|o)|saariselk(ä|a)/i, 'snow'],
  ['Swiss Alps', /zermatt|matterhorn|jungfrau|interlaken|lucerne|titlis|glacier express|swiss alps/i, 'landscape'],
  ['Charyn Canyon', /charyn/i, 'landscape'],
  ['Kolsai & Kaindy lakes', /kolsai|kaindy/i, 'leaf'],
  ['Shymbulak & Big Almaty Lake', /shymbulak|big almaty lake|medeu/i, 'landscape'],
  ['Desert safari', /desert safari|white desert|siwa|bedouin|quad bik|dune bash|sahara/i, 'sun'],
  ['Camel rides', /camel/i, 'sun'],
  ['Cliffs of Moher', /cliffs of moher|burren/i, 'landscape'],
  ["Giant's Causeway", /giant.?s causeway|dark hedges|carrick-a-rede/i, 'landscape'],
  ['Ring of Kerry', /ring of kerry|dingle|killarney national park/i, 'road'],
  ['Loch Ness & Glencoe', /loch ness|urquhart|glencoe|glenfinnan/i, 'landscape'],
  ['Isle of Skye', /isle of skye|old man of storr|quiraing|fairy pools/i, 'landscape'],
  ['Lake District', /lake district|windermere|grasmere/i, 'leaf'],
  ['Cotswolds villages', /cotswold|bibury|bourton/i, 'tree'],
  ['Madeira levada walks', /levada|funchal|madeira/i, 'leaf'],
  ['Sauna culture', /sauna/i, 'star', /finland|lapland|helsinki|sweden|norway|estonia/i],
  // Culture, temples & landmarks
  ['Pyramids of Giza', /pyramids? of giza|giza|great pyramid|khufu|saqqara|step pyramid|the sphinx|sphinx of/i, 'culture'],
  ['Luxor temples & Valley of the Kings', /valley of the kings|karnak|luxor temple|hatshepsut|colossi/i, 'culture'],
  ['Abu Simbel', /abu simbel/i, 'culture'],
  ['Philae, Edfu & Kom Ombo temples', /philae|high dam|kom ombo|edfu|temple of horus/i, 'culture'],
  ['Egyptian Museum & Tutankhamun', /egyptian museum|tutankhamun/i, 'culture'],
  ['Bazaars & souks', /medina|souk|bazaar|khan el[- ]khalili/i, 'culture', /egypt|morocco|kazakhstan|uzbekistan|turkey|dubai|oman|jordan/i],
  ['Chefchaouen blue city', /chefchaouen/i, 'camera'],
  ['Grand Palace & Bangkok temples', /grand palace|wat pho|wat arun|emerald buddha/i, 'culture'],
  ['Big Buddha & Wat Chalong', /big buddha|wat chalong/i, 'culture'],
  ['Angkor Wat', /angkor|bayon|ta prohm|banteay/i, 'culture'],
  ['Sigiriya Rock Fortress', /sigiriya|dambulla/i, 'culture'],
  ['Temple of the Tooth', /temple of the tooth|tooth relic/i, 'culture'],
  ['Galle Fort', /galle fort|dutch fort/i, 'culture'],
  ["Tiger's Nest Monastery", /tiger.?s nest|taktsang/i, 'culture'],
  ['Dzongs & monasteries', /dzong|lhakhang|chorten|buddhist monaster/i, 'culture'],
  ['Great Wall of China', /great wall|mutianyu|badaling/i, 'culture'],
  ['Terracotta Army', /terracotta (army|warriors)/i, 'culture'],
  ['Forbidden City', /forbidden city|tiananmen|temple of heaven/i, 'culture'],
  ['The Bund & Shanghai skyline', /\bbund\b|shanghai tower/i, 'camera'],
  ['Borobudur & Prambanan', /borobudur|prambanan/i, 'culture'],
  ['Uluwatu sunset & Kecak', /uluwatu/i, 'moon'],
  ['Tanah Lot temple', /tanah lot/i, 'culture'],
  ['Ubud temples', /tirta empul|ubud palace|goa gajah|saraswati/i, 'culture'],
  ['Temples & shrines', /fushimi inari|kinkaku|arashiyama|senso-?ji|meiji shrine|todai-?ji|kiyomizu|shrine/i, 'culture', /\bjapan\b|tokyo|kyoto|osaka/i],
  ['Bullet train', /shinkansen|bullet train/i, 'train'],
  ['Hot springs & onsen', /onsen|hot spring|ryokan|thermal bath|geothermal (pool|bath|spa)/i, 'star'],
  ['Alms-giving ceremony', /alms/i, 'culture'],
  ['Colosseum & ancient Rome', /colosseum|roman forum|pantheon|pompeii/i, 'culture'],
  ['Vatican & Sistine Chapel', /vatican|sistine/i, 'culture'],
  ['Wine tasting', /chianti|wine tasting|vineyard|winery|wine tour|rioja|port wine|wine cellar/i, 'wine'],
  ['Acropolis of Athens', /acropolis|parthenon/i, 'culture'],
  ["Gaudí's Barcelona", /sagrada|gaud(í|i)|park g(ü|u)ell|casa batll/i, 'culture'],
  ['Flamenco night', /flamenco/i, 'ticket'],
  ['Alhambra', /alhambra/i, 'culture'],
  ['Sintra palaces', /sintra|pena palace/i, 'castle'],
  ['Dubrovnik city walls', /dubrovnik|lokrum|game of thrones/i, 'castle'],
  ['Castles & fortresses', /castle|ch(â|a)teau|fortress|schloss|alc(á|a)zar/i, 'castle', /europe|scotland|england|wales|ireland|germany|france|spain|portugal|italy|croatia|finland|sweden|norway|denmark|austria|switzerland|czech|hungary|\bjapan\b|rajasthan/i],
  ['London landmarks', /tower of london|westminster|buckingham|london eye|big ben|british museum/i, 'camera'],
  ['Stonehenge', /stonehenge/i, 'culture'],
  ['Bath & the Roman Baths', /roman baths|thermae|royal crescent/i, 'culture'],
  ['Whisky distilleries', /whisky|distiller/i, 'wine'],
  ['Guinness Storehouse', /guinness/i, 'wine'],
  ['Paris icons', /eiffel|louvre|seine|versailles|montmartre|notre[- ]dame/i, 'camera'],
  ['Hallstatt & Salzburg', /hallstatt|salzburg|sound of music/i, 'camera'],
  ['Amsterdam canals', /amsterdam|keukenhof/i, 'boat'],
  ['Stockholm old town & museums', /gamla stan|vasa museum|abba/i, 'culture'],
  ['Street food trails', /street food|hawker|jalan alor|food trail|food tour/i, 'food'],
  ['Cooking class', /cooking class|cookery/i, 'food'],
  ['Spa & wellness', /massage|wellness|ayurved|spa (treatment|day|session|ritual)|thermal spa/i, 'gem']
];
